import React from 'react';
import { IconLongArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { Button } from '../../../types/benefit';

export const ButtonSignup = (button: Button) => {
  return (
    <TouchAccessibilityWrapper touchHeight={36} onClick={() => !button.disable && button.onClick()}>
      <Container disabled={button.disable}>
        {button.text}
        <IconLongArrowRightBold width={16} height={16} v3Color='pink400' />
      </Container>
    </TouchAccessibilityWrapper>
  );
};

const Container = styled.button<{ color?: string; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px 0 10px;
  height: 24px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;

  ${({ color }) => `
    color: ${color ?? vars.color.pink400};
  `};

  ${({ color, disabled }) =>
    disabled
      ? `color: ${vars.v3Color.gray400};
         background: ${vars.v3Color.gray150};`
      : `border: 1px solid ${color ?? vars.color.pink400};`};
`;
